import React, { useEffect, useState, useRef, useCallback } from "react";
import config from "../../config";
import { triggerNotification } from "../../component/message/Msg";
import Swal from "sweetalert2";
import { useNavigate } from "react-router-dom";
import Breadcrumb from "../../component/breadcrumb/Breadcrumb";
import Spinner from "../../component/loadingbar/Spinner";
import TableViewer from "../../component/tableViewer/TableViewer";
import noImgThing from "../../assetsCon/assets/images/noImgThing.jpg";

const ViewChapers = () => {
  const [chapters, setChapters] = useState([]);
  const [loading, setLoading] = useState(false);
  const [selectedChapter, setSelectedChapter] = useState([]);

  const token = config.token;
  const navigate = useNavigate();

  //  ------For TableViewer ------
  const chaptersRef = useRef([]);
  chaptersRef.current = chapters;
  const [rowData, setRowData] = useState([]);
  //  ------For TableViewer ------

  const viewMcq = (idNumber, courseNm) => {
    navigate(
      `/viewmcqs/chapter/${btoa(encodeURIComponent(idNumber))}/${btoa(
        encodeURIComponent(courseNm)
      )}?from=mcq`
    );
  };

  // ---------------------------------------------------- Duplicate chapter ---------------------------------------------------------
  // Show a confirmation dialog for duplicating a chapter
  const btnDuplicateChapterHandler = (duplicateId, i) => {
    Swal.fire({
      title: "Are you sure?",
      text: "You are about to duplicate this chapter. Are you sure you want to proceed?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, duplicate it!",
    }).then((result) => {
      if (result.isConfirmed) {
        handleDuplicateChapter(duplicateId, i);
      }
    });
  };

  // If confirmed, duplicate chapter
  const handleDuplicateChapter = async (duplicateId, i) => {
    try {
      const response = await fetch(
        `${config.host_url}chapter/duplicate/${duplicateId}`,
        {
          method: "GET",
          headers: {
            token: token,
          },
        }
      );

      const data = await response.json();

      if (data.status === 200) {
        triggerNotification("success", "Chapter duplicated successfully");
        fetchChapters();
        //  ------For TableViewer ------
      } else if (data.status === 404) {
        // Chapter IDs Not Found
        console.error("Chapter IDs not found");
        triggerNotification("error", "Chapter IDs not found");
      } else if (data.status === 401) {
        // Invalid Token
        console.error("Invalid token");
        triggerNotification("error", "Unauthenticated User");
      } else {
        // Internal Server Error or other HTTP errors
        console.error("Internal server error");
        triggerNotification(
          "error",
          "Internal server error, please try again later!"
        );
      }
    } catch (error) {
      console.error("Error duplicating chapter:", error);
      triggerNotification("error", "Error duplicating chapter");
    }
  };

  // ------------------------------------------------- view Result  ---------------------------------------------------- R
  const viewResult = (id, cname) => {
    const encodedId = window.btoa(encodeURIComponent(id));
    const encodedCname = window.btoa(encodeURIComponent(cname));
    navigate(`/viewtestresult/chapter/${encodedId}/${encodedCname}`);
  };

  //----------------------------------------------- select / view chapters table  -------------------------------------------------R
  // Fetch all chapters
  const fetchChapters = async () => {
    setLoading(true);
    try {
      await fetch(`${config.host_url}chapter`, {
        method: "GET",
        headers: {
          token: token,
        },
      })
        .then((response) => response.json())
        .then((data) => {
          if (data.status === 200) {
            //  ------For TableViewer ------
            const chaptersData = data.data.map((chapter) => ({
              status: chapter.status,
              chapter: chapter.name,
              image: chapter.icon ? chapter.icon : chapter.image_link,
              idNumber: chapter.chapterid,
            }));
            setRowData(chaptersData);
            //  ------For TableViewer ------
            setChapters(data.data);
          } else if (data.status === 401) {
            // Invalid token
            triggerNotification("error", "Unauthenticated user");
          } else {
            // Handle other errors
            triggerNotification(
              "error",
              "Internal server error, Please try after some time!!"
            );
          }
        });
    } catch (error) {
      triggerNotification("error", "Error fetching chapters.");
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    fetchChapters();
  }, [token]);

  //----------------------------------------------- select / view single chapter  -------------------------------------------------R
  const btnShowHandle = async (id) => {
    const encodedId = window.btoa(encodeURIComponent(id));
    navigate(`/viewchapter/${encodedId}`);
  };

  // ------------------------------------------------- Edit / Update chapter ---------------------------------------------------- U
  const btnEditHandle = (id) => {
    const encodedId = window.btoa(encodeURIComponent(id));
    navigate(`/addchapter/${encodedId}`);
  };

  // ---------------------------------------------------- Delete chapter ---------------------------------------------------------D
  // Show a confirmation dialog
  const btnDeleteHandle = (deleteId, i) => {
    Swal.fire({
      title: "Are you sure?",
      text: "You are about to delete Chapter. Are you sure you want to proceed?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    }).then((result) => {
      if (result.isConfirmed) {
        handleDeleteChapter(deleteId, i);
      }
    });
  };

  //If confirm then delete chapter
  const handleDeleteChapter = async (deleteId, i) => {
    try {
      await fetch(`${config.host_url}chapter/${deleteId}`, {
        method: "DELETE",
        headers: {
          token: token,
        },
      })
        .then(function (response) {
          return response.json();
        })
        .then(function (data) {
          if (data.status === 200) {
            triggerNotification("success", "Chapter deleted successfully");
            fetchChapters();

            //  ------For TableViewer ------
            // const updatedChapters = [...chaptersRef.current];
            // updatedChapters.splice(i, 1);
            // setChapters(updatedChapters);
            // const chaptersData = updatedChapters.map((chapter) => ({
            //   chapter: chapter.name,
            //   image: chapter.image_link,
            //   idNumber: chapter.chapterid,
            // }));
            // setRowData(chaptersData);
            //  ------For TableViewer ------
          } else if (data.status === 404) {
            // chapter IDs Not Found
            console.error("Chapter IDs not found");
            triggerNotification("error", "Chapter IDs not found");
          } else if (data.status === 401) {
            // Invalid Token
            console.error("Invalid token");
            triggerNotification("error", "Unauthenticated User");
          } else {
            // Internal Server Error or other HTTP errors
            console.error("Internal server error");
            triggerNotification(
              "error",
              "Internal server error, Please try after some time!"
            );
          }
        });
    } catch (error) {
      console.error("Error deleting chapter:", error);
      triggerNotification("error", "Error deleting chapter");
    }
  };

  //  ------For TableViewer ------
  const colDefs = [
    {
      headerName: "",
      // field: "idNumber",
      width: 50,
      checkboxSelection: true,
      // cellEditor: "agCheckboxCellEditor",
    },
    {
      headerName: "#",
      width: 50,
      valueFormatter: (params) => {
        return `${parseInt(params.node.id) + 1}`;
      },
    },
    {
      headerName: "Chapter",
      field: "chapter",
      width: 300,
      cellRenderer: (params) => (
        <div className=" flex py-1 ">
          <img
            src={params.data.image ? params.data.image : noImgThing}
            alt="chapter_Image"
            className="rounded h-11 w-11  mr-4"
          />
          <p className="p-0 m-0">{params.data.chapter}</p>
        </div>
      ),
    },
  ];

  const colDefsWithoutCheckbox = colDefs.filter(
    (colDef) => colDef.headerName !== ""
  );
  //  ------For TableViewer ------
  return (
    <>
      <Breadcrumb txt="Manage Chapter" subpath={["View Chapters"]} />
      <div className="col-xxl">
        <div className="card mb-4">
          <div className="card-header d-flex align-items-center flex justify-between">
            <h5 className="mb-0">View Chapters</h5>
            <button
              type="button"
              className="btn btn-primary"
              onClick={() => {
                navigate("/addchapter");
              }}
            >
              Add Chapter
            </button>
          </div>
          {loading ? (
            <Spinner />
          ) : (
            <div className="px-3 pb-3  table-responsive">
              {/* ------For TableViewer ------ */}
              <TableViewer
                rowData={rowData.filter((row) => row.status !== 3)}
                colDefs={colDefs}
                onEdit={btnEditHandle}
                onDelete={btnDeleteHandle}
                onView={btnShowHandle}
                onMcqView={viewMcq}
                onDuplicate={btnDuplicateChapterHandler}
                    //for delete chapters
                fetchDataAfterAction={fetchChapters}
                tableTitle="View Chapters"
                btnTxtFor="chapters"
                btnTxtAction={["delete"]}
                actionUrl="chapter/move/4"
                // onResult={viewResult}
                // resultOf="chapter"
                // haveImage
              />
              {/* ------For TableViewer ------ */}
            </div>
          )}
        </div>

        {/* draft */}
        <div className="card mb-4">
          {loading ? (
            <Spinner />
          ) : (
            <div className="px-3 pb-3  table-responsive">
              {/* ------For TableViewer ------ */}
              <TableViewer
                rowData={rowData.filter((row) => row.status === 3)}
                colDefs={colDefs}
                onEdit={btnEditHandle}
                onDelete={btnDeleteHandle}
                fromDraft={true}
                //for delete chapter
                fetchDataAfterAction={fetchChapters}
                tableTitle="View Chapters - Draft"
                btnTxtFor="chapters"
                btnTxtAction={["delete","publish"]}
                actionUrl="chapter/move/4"
              />
              {/* ------For TableViewer ------ */}
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default ViewChapers;
